export interface ForceCacheResponseJSON {
  data: ForceCacheStateJSON;
}

interface ForceCacheStateJSON {
  enabled: boolean;
}

export class ForceCacheState {
  public constructor(public enabled: boolean) {}

  public static fromJSON(json: ForceCacheStateJSON): ForceCacheState {
    return new ForceCacheState(json.enabled);
  }
}
